import { render, staticRenderFns } from "./ExclusionCreate.vue?vue&type=template&id=8962a8ca&"
import script from "./ExclusionCreate.vue?vue&type=script&lang=js&"
export * from "./ExclusionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports